import * as Types from '../constants/actionTypes';

export default (state = {
  list: [],
  errorMessage: ''
}, action) => {
  switch (action.type) {
    case Types.MANUFACTURER_LIST: {
      return {
        ...state,
        list: action.payload,
        errorMessage: '',
      }
    }
    case Types.MANUFACTURER_DETAIL_SUCCESS:
        return {
            ...state,
            list: action.payload,
            errorMessage: ''
        }
    case Types.MANUFACTURER_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage
      }
    case Types.MANUFACTURER_INFO_COUNT_SUCCESS:
            return Object.assign({}, state, { labelInfoCount: action.payload})
    default:
      return state;
  }
};